export default __webpack_public_path__ + "static/media/CENI.0c2b9319.png";